// removed by extract-text-webpack-plugin
module.exports = {"richLabel":"richLabel__1PCTo","translated":"translated__1kvLM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichLabel/styles.scss
// module id = 2144
// module chunks = 1